/**
 * The Ledger account step, as a one-slot bridge between the adapter and our modal.
 *
 * `LedgerAdapter` asks for the account through a `selectAccount` callback rather than an
 * event, and it has its own bundled modal for that. We disable theirs and answer with
 * ours: the adapter calls `requestLedgerAccount`, the modal renders the list and calls
 * `choose` or `cancel`. Importing nothing from the adapter keeps this file free for the
 * facade to reference.
 */
let chooser = null;
/** The modal registers itself while it is mounted, and clears the slot when it is not. */
export function setLedgerAccountChooser(next) {
    chooser = next;
}
export function requestLedgerAccount(input) {
    return new Promise((resolve, reject) => {
        if (!chooser) {
            // Without a chooser the first derived account is the only sensible answer, and
            // silently using it is better than hanging on a promise nobody will settle.
            const first = input.accounts[0];
            if (first)
                return resolve(first);
            return reject(new Error("The Ledger returned no accounts"));
        }
        chooser({
            accounts: input.accounts,
            loadMore: input.getAccounts,
            choose: resolve,
            cancel: (reason) => reject(reason ?? new Error("The account choice was cancelled")),
        });
    });
}
//# sourceMappingURL=ledger-accounts.js.map